// extracted by mini-css-extract-plugin
export default {"container":"app_container__bW-dC","loader":"app_loader__pjnxG"};